import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface ShareButtonDriver extends BaseUniDriver {}

export const shareButtonDriverFactory = (
  base: UniDriver,
): ShareButtonDriver => {
  return {
    ...baseUniDriverFactory(base),
  };
};
